var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",attrs:{"src":_vm.src,"alt":""},on:{"click":function($event){return _vm.$router.push({ name: _vm.pageRoutes.WORKSPACE })}}})}
var staticRenderFns = []

export { render, staticRenderFns }